import { motion } from 'framer-motion';
import { Clock, Mail, MapPin, Phone, Send } from 'lucide-react';
import { CONTACT } from '../constants/testIds';
import { SITE_CONTENT } from '../lib/siteContent';

const ADDRESS = `${SITE_CONTENT.address.street}, ${SITE_CONTENT.address.city}, Ohio ${SITE_CONTENT.address.postalCode}`;
const PHONE_DISPLAY = SITE_CONTENT.phoneDisplay;
const PHONE_TEL = `tel:${SITE_CONTENT.phone}`;
const EMAIL = SITE_CONTENT.email;

export const Contact = () => (
  <section id="contact" data-testid={CONTACT.section} className="relative bg-brand-surface py-24 sm:py-32 border-t border-brand-border/60">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
        <p className="font-mono text-xs uppercase tracking-widest text-brand-amber mb-3">Get in Touch</p>
        <h2 className="font-display font-extrabold uppercase tracking-tight text-brand-text text-3xl sm:text-4xl lg:text-5xl">
          Let's Talk Tires
        </h2>

        <div className="mt-8 space-y-5">
          <a href={`mailto:${EMAIL}`} data-testid={CONTACT.email} className="flex items-start gap-3 text-brand-text text-base sm:text-lg hover:text-brand-orange transition-colors">
            <Mail className="w-5 h-5 text-brand-orange mt-0.5 shrink-0" />
            {EMAIL}
          </a>
          <a href={PHONE_TEL} data-testid={CONTACT.phone} className="flex items-start gap-3 text-brand-text text-base sm:text-lg hover:text-brand-orange transition-colors">
            <Phone className="w-5 h-5 text-brand-orange mt-0.5 shrink-0" />
            {PHONE_DISPLAY}
          </a>
          <p className="flex items-start gap-3 text-brand-muted text-sm sm:text-base">
            <Clock className="w-5 h-5 text-brand-orange mt-0.5 shrink-0" />
            Monday – Friday: 8:00 AM – 5:00 PM EST
          </p>
          <p data-testid={CONTACT.address} className="flex items-start gap-3 text-brand-muted text-sm sm:text-base">
            <MapPin className="w-5 h-5 text-brand-orange mt-0.5 shrink-0" />
            {ADDRESS}
          </p>
          <p className="text-brand-muted text-sm max-w-md">
            We're an international brand shipping worldwide through our partner freight network — this address is our sales &amp; logistics office only.
          </p>
        </div>

        <div className="mt-9 flex flex-wrap gap-4">
          <a
            href="#order-form"
            data-testid={CONTACT.ctaBookMeeting}
            className="inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangeHover text-white font-display font-bold uppercase tracking-wide rounded-full px-6 py-3 transition-colors"
          >
            <Send className="w-4 h-4" />
            Start Your Order
          </a>
          <a
            href={`mailto:${EMAIL}`}
            data-testid={CONTACT.ctaEmail}
            className="inline-flex items-center gap-2 border border-brand-border text-brand-text font-display font-bold uppercase tracking-wide rounded-full px-6 py-3 hover:border-brand-amber transition-colors"
          >
            <Mail className="w-4 h-4" />
            Email Us
          </a>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.97 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="rounded-2xl border border-brand-border bg-brand-surface2 aspect-[4/3] overflow-hidden relative"
      >
        <img
          src="/images/brand/warehouse-aisle-blue.jpg"
          alt="BulkUsedTires.com warehouse used for sorting and preparing freight orders"
          className="w-full h-full object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-bg/80 via-transparent to-transparent" />
        <div className="absolute bottom-5 left-5 font-mono text-xs uppercase tracking-widest text-brand-amber bg-brand-bg/80 border border-brand-border rounded-full px-4 py-1.5">
          Worldwide &amp; Export Freight
        </div>
      </motion.div>
    </div>
  </section>
);
